// © Thibault Sabathier, 2026. Tous droits réservés.
// frontend/src/views/jobs/searches/CareerStatusSuggestion.js
//
// Proposition FACULTATIVE après la publication d'une recherche d'opportunité : « Vous cherchez
// activement. Souhaitez-vous l'indiquer sur votre profil ? ». Rien n'est modifié sans un clic
// explicite sur « Oui » ; « Non merci » ferme simplement la proposition.
//
// Même endpoint et même mécanique que CareerStatusCard (PUT /members/:id, champ career_status).

import React, { useRef, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { CAlert, CButton, CSpinner } from '@coreui/react'
import { put } from '../../../utils/apiClient'
import './searches.scss'

const CareerStatusSuggestion = ({ memberId, status, onDone }) => {
  const { t } = useTranslation()
  const [saving, setSaving] = useState(false)
  const [error, setError] = useState(null)
  const lock = useRef(false)

  const accept = async () => {
    if (lock.current) return
    lock.current = true
    setSaving(true)
    setError(null)
    try {
      const form = new FormData()
      form.append('career_status', status)
      await put(`/members/${memberId}`, form)
      onDone(true)
    } catch (err) {
      setError(t('searches:errors.generic'))
    } finally {
      lock.current = false
      setSaving(false)
    }
  }

  return (
    <CAlert color="info" className="ms-suggestion">
      <div className="fw-semibold">{t('searches:career.title')}</div>
      <div className="mb-2">{t('searches:career.body')}</div>
      {error && <div className="text-danger small mb-2">{error}</div>}
      <div className="d-flex gap-2 flex-wrap">
        <CButton size="sm" color="primary" disabled={saving} onClick={accept}>
          {saving && <CSpinner size="sm" className="me-2" />}
          {t('searches:career.accept')}
        </CButton>
        <CButton
          size="sm"
          color="secondary"
          variant="outline"
          disabled={saving}
          onClick={() => onDone(false)}
        >
          {t('searches:career.decline')}
        </CButton>
      </div>
    </CAlert>
  )
}

export default CareerStatusSuggestion
